import './Navagator.less';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { infoController } from '@/api/index';
import { useApi } from '@/hooks/useApi.jsx';
import ImgHome from '@/assets/layouts/dashboard/home_nav_home.png';
import ImgHome1 from '@/assets/layouts/dashboard/home_nav_home-1.png';
import ImgSetting from '@/assets/layouts/dashboard/home_nav_settings.png';
import ImgSetting1 from '@/assets/layouts/dashboard/home_nav_settings-1.png';
import ImgSpace from '@/assets/layouts/dashboard/home_nav_space.png';
import ImgSpace1 from '@/assets/layouts/dashboard/home_nav_space-1.png';
import { useTranslation } from 'react-i18next';
function DashboardLeft({ value }) {
  const { data: orderManageData, error: orderManageError } = useApi(infoController.orderManage);
  const navigate = useNavigate();
  const location = useLocation();
  const [btnActive, setBtnActive] = useState('/home');

  const [pageInit, setPageInit] = useState(false);
  // const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setBtnActive(location.pathname);
  }, [location]);

  useEffect(() => {
    if (value) {
      if (pageInit) return;
      setPageInit(true);
    }
  }, [value, pageInit]);

  const handleToPage = (path) => {
    navigate(path);
  };

  useEffect(() => {
    if (orderManageData?.code === 0) {
      window.open(orderManageData.data);
    } else if (orderManageError) {
      console.log('获取权益时发生错误:', orderManageError);
    } else {
      console.log(orderManageData, '312312');
    }
  }, [orderManageData, orderManageError]);

  return (
    <div className="dashboard_left_box">
      <div className="top_box">
        <button
          onClick={() => {
            window.onClickGATrackEvent('menu-home');
            handleToPage('/home');
          }}
          className={`btn pagebtn ${btnActive === '/home' ? 'btn-accent' : 'btn-ghost'}`}>
          <img src={btnActive === '/home' ? ImgHome1 : ImgHome} alt="" className="navicon" />
          {t('As_Edit_SpaceProject334')}
        </button>
        <button
          onClick={() => {
            window.onClickGATrackEvent('menu-space');
            handleToPage('/space');
          }}
          className={`btn pagebtn ${btnActive === '/space' ? 'btn-accent' : 'btn-ghost'}`}>
          <img src={btnActive === '/space' ? ImgSpace1 : ImgSpace} alt="" className="navicon" />
          {t('As_Home_Sidebar2')}
        </button>
        <button
          onClick={() => {
            window.onClickGATrackEvent('menu-settings');
            handleToPage('/settings');
          }}
          className={`btn pagebtn ${btnActive === '/settings' ? 'btn-accent' : 'btn-ghost'}`}>
          <img
            src={btnActive === '/settings' ? ImgSetting1 : ImgSetting}
            alt=""
            className="navicon"
          />
          {t('As_Home_Sidebar3')}
        </button>
      </div>
    </div>
  );
}

export default DashboardLeft;
